import { createFileRoute } from '@tanstack/react-router';
import { DropOffLocationsScreen } from '@/features/buying/drop-off/DropOffLocationsScreen';

/**
 * Vendors › Drop-off locations (TASK-0256, DROP-1). Un-nested (`vendors_`) so it does not inherit the
 * `/vendors` list's search schema, like `vendors_.catalogs.tsx`.
 */
export const Route = createFileRoute('/_app/vendors_/drop-off-locations')({
  staticData: { crumb: 'Drop-off locations' },
  component: DropOffLocationsScreen,
});
